export default "__VITE_ASSET__715808d9__"